import { render, staticRenderFns } from "./IndexFive.vue?vue&type=template&id=b3eec94a&"
import script from "./IndexFive.vue?vue&type=script&lang=js&"
export * from "./IndexFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports